import { RestockingListTypesEnum } from './RestockingTypes'

export const fixInputSx = {
  '& .MuiInputLabel-outlined': {
    transform: 'translate(14px, 13px) scale(1) !important',
  },
  '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
    transform: 'translate(14px, -9px) scale(0.75) !important',
  },
}

export const transferTypes = [
  RestockingListTypesEnum.TRANSFER,
  RestockingListTypesEnum.TRANSFER_LOSS_PREVENTION,
]
